import { AiFillStar } from 'react-icons/ai'

import { Box, Tooltip } from '@chakra-ui/react'

export const DefaultFloorIndicator = () => {
  return (
    <Tooltip label='Default floor' placement='bottom'>
      <Box>
        <AiFillStar color='#44546F' size={20} />
      </Box>
    </Tooltip>
  )
}
